var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocument = function SvgDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 401 400"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.4 336c0 4.66-3.51 8.47-7.8 8.47H77.27c-4.29 0-7.8-3.81-7.8-8.47V64c0-4.66 3.51-8.47 7.8-8.47H327.6c4.29 0 7.8 3.81 7.8 8.47v271.99ZM74.92 157.42h258.53M104.94 115.71h23.13M152.8 115.71h23.12",
    className: "document_svg__cls-1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.57 200.44h-84.32M292.57 245.51h-84.32M292.57 290.65H115.81M116.5 200.44h47.86v45.06H116.5z",
    className: "document_svg__cls-2"
  }))));
};
export default SvgDocument;